var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      { attrs: { role: "radiogroup" } },
      "div",
      _vm.groupAttributes,
      false
    ),
    _vm._l(_vm.options, function (option, idx) {
      return _c(
        "label",
        _vm._b(
          {
            key: idx,
            on: {
              click: function ($event) {
                return _vm.$emit("input", idx)
              },
            },
          },
          "label",
          _vm.buttonAttributes(idx),
          false
        ),
        [
          _c("input", {
            attrs: { name: _vm.name, autocomplete: "off", type: "radio" },
            domProps: { value: idx, checked: idx === _vm.value },
            on: {
              change: function ($event) {
                return _vm.$emit("input", idx)
              },
            },
          }),
          _vm._v(" " + _vm._s(option) + "\n  "),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }